<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <div class="d-flex justify-content-between">
        <h3>حملات التبرع</h3>
        <!-- <b-button
          v-can="{ slug: $route.meta.slug, action: 'C' }"
          variant="success"
          @click="isModalVisible = true"
          v-if="canAddTransaction"
        >
          <feather-icon icon="PlusIcon" />
          إضافة</b-button
        > -->
      </div>

      <hr />
      <div>
        <div v-if="!loading">
          <campaign-card
            v-can="{ slug: $route.meta.slug, action: 'S' }"
            v-for="item in campaigns"
            :key="item.id"
            :info="item"
            @editClicked="openEditCampaignModal(item)"
            @deleteClicked="deleteCampaign({ id: item.id, page: currentPage })"
          ></campaign-card>

          <alert
            massage="عذراً لا يوجد نتائج لعرضها"
            class="w-100"
            v-if="!loading && campaigns.length === 0"
          />
        </div>
        <pagination
          v-can="{ slug: $route.meta.slug, action: 'S' }"
          v-if="!loading"
          v-model="currentPage"
          :currentPage.sync="currentPage"
          :total-rows="pagination.total_row"
          :per-page="pagination.per_page"
          align="end"
          class="mt-2"
        >
        </pagination>

        <form-modal
          v-model="isModalVisible"
          title="معلومات الحملة"
          :formSchema="formSchema"
          ref="campaignModal"
          @confirm="handleCampaignSubmit"
          :loading="working"
          static
        >
          <template #number="{ form }">
            <form-cleave
              v-model="form.number"
              v-if="form.campaign_type === 0"
              rules="required"
              label="العدد"
              isNumber
              :charsCount="15"
            />
          </template>
          <template #campaign_amount="{ form }">
            <form-currency
              v-model="form.campaign_amount"
              v-if="form.campaign_type === 1"
              rules="required"
              label="مبلغ التبرع"
            />
          </template>
          <template #description_ar="{ form }">
            <b-form-group label="التفاصيل" label-for="details">
              <validation-provider
                #default="{ errors }"
                name="حقل التفاصيل"
                rules="required"
                id="details"
                mode="passive"
              >
                <quill-editor v-model="form.description_ar"
                :options="editorOption" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </template>
        </form-modal>
      </div>
    </div>
  </b-card>
</template>
<script>
import { BCard, BButton, BPagination, BFormGroup } from "bootstrap-vue";
import CampaignCard from "../../components/CampaignCard.vue";
import ModalCampaign from "../../components/ModalCampaign.vue";
import Pagination from "@/components/pagination/index.vue";
import Alert from "@/components/Alert.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import FormCurrency from "@/components/FormCurrency.vue";
import FormCleave from "@/components/FormCleave";
import { ValidationProvider } from "vee-validate";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    Alert,
    BCard,
    BButton,
    CampaignCard,
    ModalCampaign,
    BPagination,
    Pagination,
    LoadingOverlay,
    FormModal,
    FormCurrency,
    FormCleave,
    ValidationProvider,
    quillEditor,
    BFormGroup,
  },
  data() {
    return {
      isModalVisible: false,
      currentPage: 1,
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
      formSchema: {
        image: {
          component: "FormImageInput",
          key: "image",
          attrs: {
            label: "صورة الحملة",
            id: "form-image",
            name: "image",
            rules: "required",
          },
        },
        name_ar: {
          component: "FormInput",
          key: "name_ar",
          attrs: {
            label: "اسم الحملة",
            rules: "required",
          },
        },
        campaign_type: {
          component: "FormSelect",
          key: "campaign_type",
          attrs: {
            label: "نوع الحملة",
            id: "event-type",
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
            rules: "required",
            options: [
              { value: 1, title: "مادية" },
              { value: 0, title: "عينية" },
            ],
          },
        },
        age_category_id: {
          component: "FormSelect",
          key: "age_category_id",
          attrs: {
            label: "الفئات المستهدفة",
            id: "age-categories",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
            ep: "/v2/selects/age-categories",
            multiple: true,
            closeOnSelect: false,
          },
        },
        number: { key: "number" },
        campaign_amount: { key: "campaign_amount" },
        start_date: {
          component: "FormMask",
          key: "start_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ بداية الحملة",
            rules: "required",
          },
        },
        end_date: {
          component: "FormMask",
          key: "end_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ نهاية الحملة",
            rules: "required",
          },
        },
        governorate_id: {
          component: "FormSelect",
          key: "governorate_id",
          attrs: {
            label: "المحافظة",
            id: "campaign-governorate",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
            ep: "/v2/selects/governorates",
          },
        },
        description_ar: { key: "description_ar" },
      },
    };
  },
  methods: {
    ...mapActions("manageInterfaceNgo/ngoCampaign", [
      "createCampaign",
      "updateCampaign",
      "getCampaigns",
      "deleteCampaign",
    ]),
    openEditCampaignModal(form) {
      var toUpdate = { ...form };
      toUpdate.governorate_id = form.governorate ? form.governorate.id : null;
      delete toUpdate.governorate;
      toUpdate.age_category_id = form.ageCategories
        ? form.ageCategories.map((el) => el.id)
        : [];
      delete toUpdate.ageCategories;
      this.$refs.campaignModal.init(toUpdate);
      this.isModalVisible = true;
    },
    handleCampaignSubmit(form) {
      if (form.id) {
        this.updateCampaign({ form, page: this.currentPage }).then(() => {
          this.isModalVisible = false;
        });
      } else {
        this.createCampaign({ form, page: this.currentPage }).then(() => {
          this.isModalVisible = false;
        });
      }
    },
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/ngoCampaign", [
      "campaigns",
      "loading",
      "pagination",
      "working",
    ]),
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(value) {
        this.getCampaigns({ page: value , status :'A'});
      },
    },
  },
};
</script>

<style lang="scss">
.status-btns {
  .btn:disabled {
    opacity: 1 !important;
  }
}
</style>
